import { Dartboard } from './Dartboard';

window.customElements.define('dartbot-dartboard', Dartboard);
